import { useEffect, useRef } from 'react';

const FAVICON_LINK_IDS = [
  'sz-favicon',
  'sz-logo-32x32',
  'sz-logo-16x16',
  'sz-apple-touch-icon',
];

const BLANK_ICON = 'data:,';

export function useHideFaviconWhenCoBranded(hasCoBranding: boolean) {
  const originalHrefs = useRef<Record<string, string>>({});

  useEffect(() => {
    FAVICON_LINK_IDS.forEach(id => {
      const link = document.getElementById(id) as HTMLLinkElement | null;
      if (!link) {
        return;
      }

      if (!(id in originalHrefs.current)) {
        originalHrefs.current[id] = link.href;
      }

      link.href = hasCoBranding ? BLANK_ICON : originalHrefs.current[id];
    });
  }, [hasCoBranding]);
}
